import { makeStyles } from "tss-react/mui";
import { Box, Typography, TypographyProps } from "@mui/material";

export const MiTemplateBadge = ({
  title = "- -",
  backgroundColor,
  fontStyles = { fontSize: 8, fontWeight: 600, lineHeight: 1.2 },
  className,
}: {
  title?: string;
  backgroundColor?: string;
  fontStyles?: TypographyProps["sx"];
  className?: string;
}) => {
  const { classes, theme } = useStyles();
  return (
    <Box
      className={`${classes.badge} ${className}`}
      style={{ backgroundColor: backgroundColor ?? theme.palette.grey[800] }}
    >
      <Typography sx={fontStyles} color={theme.palette.common.white}>
        {title}
      </Typography>
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  badge: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(0.5, 1),
    borderRadius: 2,
    textTransform: "uppercase",
  },
}));
